<template>
  <footer>
    <div class="footer-container">
      <svg-icon icon-class="icon_logo_footer" class-name="f-logo"></svg-icon>
      <p class="f-tel">
        <a href="tel:0755 - 28115311">Tel：0755 - 28115311</a>
      </p>
      <p class="f-email">E-mail：service@houkeyun.com</p>
      <p class="f-address">地址: 深圳市南山数字文化产业基地西塔楼1007</p>
      <img class="f-qr" src="~@/assets/imgs/qr_weChat.png" alt />
      <p>关注公众号</p>
      <p class="f-name">厚科云健康科技有限公司 © | 厚科云</p>
      <p class="f-copy">粤ICP备15112511号-1 powered by Houkeyun</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss">
footer {
  width: 100%;
  height: 1000px;
  background: #1b1f23;
  padding: 88px;
  .footer-container {
    padding: 56px 0 56px 40px;
    font-size: 24px;
    font-weight: 400;
    color: #aeafb1;
    line-height: 34px;
    border-top: 2px solid #aeafb1;
    .f-logo {
      width: 378px;
      height: 80px;
      margin-bottom: 56px;
    }
    .f-tel {
      margin-bottom: 34px;
      a {
        color: #aeafb1;
      }
    }
    .f-qr {
      width: 290px;
      height: 290px;
      margin: 30px 0 16px;
    }
  }
}
</style>